const C = {
  name: "MarketplaceLaptop",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.32297 1H19.677L22 6.80742V8C22 9.01648 21.6226 9.94332 21 10.6483V16C21 17.6523 19.6523 19 18 19H6C4.34772 19 3 17.6523 3 16V10.6483C2.37741 9.94332 2 9.01648 2 8V6.80742L4.32297 1ZM18 12C16.8042 12 15.7324 11.4777 15 10.6483C14.2676 11.4777 13.1958 12 12 12C10.8042 12 9.73243 11.4777 9 10.6483C8.26757 11.4777 7.19581 12 6 12C5.65459 12 5.31952 11.9564 5 11.8744V16C5 16.5477 5.45228 17 6 17H18C18.5477 17 19 16.5477 19 16V11.8744C18.6805 11.9564 18.3454 12 18 12ZM4 8C4 9.10772 4.89228 10 6 10C7.10772 10 8 9.10772 8 8H4ZM8.1803 6L8.7803 3H5.67703L4.47703 6H8.1803ZM13.7803 6L13.1803 3H10.8199L10.2199 6H13.7803ZM15.8199 6H19.523L18.323 3H15.2199L15.8199 6ZM16 8C16 9.10772 16.8923 10 18 10C19.1077 10 20 9.10772 20 8H16ZM10 8C10 9.10772 10.8923 10 12 10C13.1077 10 14 9.10772 14 8H10Z" fill="currentColor"/>
<path d="M0 21V23H24V21H0Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as MarketplaceLaptop
};
